import { AlertProvider } from 'components/providers'
import { RouterProvider } from 'react-router'
import { useDefaultFont } from 'utils'
import router from './utils/routing'

function App() {
  useDefaultFont()
  return (
    <AlertProvider>
      <RouterProvider router={router} />
    </AlertProvider>
  )
}

export default App
